import { createPerimeter } from 'vue-kindergarten';

export default createPerimeter({
  purpose: 'lawyer',
  can: {
    viewPurchaserLawyerData() {
      return this.isLawyerGroup() || this.isLawyerPurchaser();
    },
    viewMarketingButton() {
      return this.isSuper() || this.isOciBroker() || this.isOciSales();
    },
    viewPurchaserLawyerDashboard() {
      return this.isSuper() || this.isLawyerGroup() || this.isLawyerPurchaser();
    },
    viewRequestDocsButton() {
      return this.isSuper() || this.isOciBroker() || this.isLawyerPurchaser();
    }
  },

  isLawyerGroup() {
    return this.child.isLawyerGroup;
  },
  isLawyerPurchaser() {
    return this.child.isLawyerPurchaser;
  },
  isLawyer() {
    return this.child.isLawyer;
  },
  isSuper() {
    return this.child.isSuper;
  },
  isOciBroker() {
    return this.child.isOciBroker;
  },
  isOciSales() {
    return this.child.isOciSales;
  }



});
